import {
  ReactElement, useEffect, useMemo, useState,
} from 'react';
import { UnitsInfoContainer } from 'pages/NewOverview/components/Loading/styles';
import { LoadingUnitsInfo } from 'pages/NewOverview/components/Loading/UnitsInfo';
import { ThermalComfortUnitCard } from './Card';
import { useThermalComfortDataContext } from 'pages/NewOverview/contexts/ThermalComfortDataContext';
import { useHistory } from 'react-router-dom';
import { handleFilterStateRoute } from 'pages/NewOverview/helpers/filters';
import { getUserProfile } from 'helpers/userProfile';
import { useFilterContext } from 'pages/NewOverview/contexts/FilterContext';

interface UnitsInfoProps {
  hasThermalComfort: boolean;
  loading: boolean;
}

export function UnitsInfo({
  hasThermalComfort,
  loading,
}: Readonly<UnitsInfoProps>): ReactElement {
  const [profile] = useState(getUserProfile());
  const { selectedOptions, client } = useFilterContext();
  const history = useHistory();
  const { loading: loadingThermal, data, refetch } = useThermalComfortDataContext();

  const generalLoading = useMemo(() => loading || (loadingThermal && hasThermalComfort), [hasThermalComfort, loading, loadingThermal]);

  function onClickDetails(): void {
    history.push('/analise/ambientes', handleFilterStateRoute(client, selectedOptions, profile));
  }

  useEffect(() => {
    if (hasThermalComfort) {
      refetch(Number(client), selectedOptions);
    }
  }, [
    selectedOptions.group?.units,
    selectedOptions.state,
    selectedOptions.status,
  ]);

  if (generalLoading) {
    return (
      <LoadingUnitsInfo />
    );
  }

  return (
    <UnitsInfoContainer data-testId="thermal-confort-units-info">
      <ThermalComfortUnitCard
        variant="comfortable"
        value={hasThermalComfort && !loading ? data?.comfortable : undefined}
        onClickDetails={onClickDetails}
      />
      <ThermalComfortUnitCard
        variant="belowLimit"
        value={hasThermalComfort && !loading ? data?.belowLimit : undefined}
        onClickDetails={onClickDetails}
      />
      <ThermalComfortUnitCard
        variant="aboveLimit"
        value={hasThermalComfort && !loading ? data?.aboveLimit : undefined}
        onClickDetails={onClickDetails}

      />
      <ThermalComfortUnitCard
        variant="inoperative"
        value={hasThermalComfort && !loading ? data?.inoperative : undefined}
        onClickDetails={onClickDetails}
      />
    </UnitsInfoContainer>
  );
}
